import * as Yup from "yup";

export const AuthSchema = Yup.object({
	email: Yup.string().required("Enter your email address").email("Enter a valid email address"),
});

export const ForgotSchema = Yup.object({
	email: Yup.string().required("Enter your email address").email("Enter a valid email address"),
});

export const VerificationEmailSchema = Yup.object({
	password: Yup.string()
		.min(6, "Your password is too short.")
		.oneOf([Yup.ref("password_confirmation"), null], "Passwords confirm must match")
		.required(),
	password_confirmation: Yup.string().oneOf([Yup.ref("password"), null], "Passwords must match"),
});

export const SignInSchema = Yup.object({
	email: Yup.string().trim().required("Enter your email address").email("Enter a valid email address"),
	password: Yup.string().required("Enter your password").min(6, "Password must be at least 6 characters"),
});
